import "whatwg-fetch";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import IdleVue from "idle-vue";
import EventBus from "./utility/Eventbus";

Vue.config.productionTip = false;
Vue.use(IdleVue, {
  eventEmitter: EventBus,
  store,
  idleTime: 10000,
  startAtIdle: false
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
